function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { CssContainer } from "../../components/container";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import Auth from "../../functions/authenticate";
import { Card, Empty } from "../../components/analytics-kit";
import { hasTenantFeature } from "../../functions/tenant-features";
import { num, emailSvc, triggerLabel } from "../email-automation/common";
import { EmailHeader } from "../email-automation/email-header";
import { money } from "../email-campaigns/api";
import { journeySvc, isSingleJourney, triggerText, triggerSentence, waitPhrase, journeyStepLabels, agoText, statusWord } from "./common";
import { shopifyOwnsJourney } from "./templates";
import { getOnboardingStatus } from "../../functions/onboarding-status";

/*
 * Journeys list (EMAIL_JOURNEYS_UX.md; Email redesign 2026-10-09 mockup Journeys.dc.html).
 * The shared Email header, status pills, then every journey and single email as a card:
 * name + status, the journey as a sentence of steps, and a footer of plain numbers.
 * Card actions (Duplicate, Pause, Resume, Archive, Restore, Use template, Compare) sit in
 * a ··· menu. "Compare journeys" enters the cross-journey funnel mode (up to four).
 *
 * 2026-10-04: single triggered emails (the /automations rail) show here too, with their own
 * detail page. Health/revenue fields come from the list endpoint and hide while absent.
 */

const DAY = 86400000;

// Relative age (kept for callers): "3 d ago", "never".
export function relAge(iso) {
  if (!iso) return "never";
  const t = new Date(iso).getTime();
  if (!isFinite(t)) return "unknown";
  const s = Math.max(0, Date.now() - t);
  if (s < 3600000) return "just now";
  if (s < DAY) return `${Math.round(s / 3600000)} h ago`;
  const d = Math.round(s / DAY);
  if (d < 60) return `${d} d ago`;
  return `${Math.round(d / 30)} mo ago`;
}

// A running journey that has enrolled nobody in two weeks is almost always a wiring problem, not a quiet audience.
export function stalled(j) {
  if (!j || j.status !== "Running" || j.isTemplate) return false;
  if (!("enrolledLast14d" in j) || Number(j.enrolledLast14d) !== 0) return false;
  if (!j.lastEnrolledDate) return true;
  const t = new Date(j.lastEnrolledDate).getTime();
  return !isFinite(t) || Date.now() - t > 14 * DAY;
}

// Ready-made starting points the journey editor offers (editor TEMPLATES keys, opened via ?template=).
const READY_MADE = [["welcome", "Welcome series"], ["browse", "Browse follow-up"], ["cart", "Cart recovery"], ["single", "Single email"]];
const pctOf = (n, d) => Number(d) > 0 ? `${Math.round((Number(n) || 0) / Number(d) * 100)}%` : null;
class CardMenu extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "outside", e => {
      if (this.state.open && this.ref.current && !this.ref.current.contains(e.target)) this.setState({
        open: false,
        confirm: null
      });
    });
    _defineProperty(this, "esc", e => {
      if (e.key === "Escape" && this.state.open) this.setState({
        open: false,
        confirm: null
      });
    });
    this.state = {
      open: false,
      confirm: null
    };
    this.ref = /*#__PURE__*/React.createRef();
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.outside);
    document.addEventListener("keydown", this.esc);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.outside);
    document.removeEventListener("keydown", this.esc);
  }
  render() {
    const {
      items,
      disabled
    } = this.props;
    const {
      open,
      confirm
    } = this.state;
    if (!items.length) return null;
    return /*#__PURE__*/React.createElement("span", {
      className: "ejl-menu",
      ref: this.ref,
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ejl-more",
      "aria-label": "More actions",
      "aria-haspopup": "menu",
      "aria-expanded": open,
      disabled: disabled,
      onClick: () => this.setState({
        open: !open,
        confirm: null
      })
    }, "\xB7\xB7\xB7"), open ? /*#__PURE__*/React.createElement("div", {
      className: "ejl-menu-list",
      role: "menu"
    }, confirm ? /*#__PURE__*/React.createElement("div", {
      className: "ejl-menu-confirm"
    }, /*#__PURE__*/React.createElement("span", null, confirm.confirm), /*#__PURE__*/React.createElement("span", {
      className: "row"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: () => this.setState({
        confirm: null
      })
    }, "Cancel"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "danger",
      onClick: () => {
        this.setState({
          open: false,
          confirm: null
        });
        confirm.run();
      }
    }, confirm.confirmLabel || "Yes"))) : items.map(it => /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      key: it.label,
      className: it.danger ? "danger" : "",
      title: it.title || undefined,
      onClick: () => {
        if (it.confirm) {
          this.setState({
            confirm: it
          });
          return;
        }
        this.setState({
          open: false
        });
        it.run();
      }
    }, it.label))) : null);
  }
}
class EmailJourneysViewComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "open", id => () => this.props.history.push(`/Email/journeys/detail/${id}`));
    _defineProperty(this, "duplicate", async j => {
      if (this.state.busyId) return;
      this.setState({
        busyId: j.id,
        notice: null
      });
      try {
        const d = await journeySvc(`/${j.id}/duplicate`).postAsync({});
        const newId = d && (d.id != null ? d.id : d.journeyId);
        if (!newId) throw new window.Error("no id");
        this.props.history.push(`/Email/journeys/edit/${newId}`);
      } catch (err) {
        if (this._alive) this.setState({
          busyId: null,
          notice: `"${j.name}" could not be duplicated. Try again.`
        });
      }
    });
    // Pause / Resume / Archive / Restore through the same status endpoint the journey page uses.
    _defineProperty(this, "setStatus", async (j, next, patch) => {
      if (this.state.busyId) return;
      this.setState({
        busyId: j.id,
        notice: null
      });
      try {
        await journeySvc(`/${j.id}/status`).putAsync({
          status: next
        });
        await this.reload(patch);
      } catch (e) {
        const needsPage = e && (e.statusCode === 409 || e.status === 409 || /errors|needsShopifyConfirm/.test(String(e.message || "")));
        if (this._alive) this.setState({
          busyId: null,
          notice: needsPage ? `"${j.name}" needs a look before it can run again. Open it to see what to fix.` : `"${j.name}" could not be changed. Try again.`
        });
      }
    });
    // Cross-journey funnel (DS 2026-10-04): the same stages for up to four journeys side by side, from GET {id}/funnel totals.
    _defineProperty(this, "toggleCompare", async id => {
      const sel = (this.state.compare || []).slice();
      const i = sel.indexOf(id);
      if (i >= 0) sel.splice(i, 1);else {
        if (sel.length >= 4) return;
        sel.push(id);
      }
      this.setState({
        compare: sel
      });
      if (i < 0 && !(this.state.funnels || {})[id]) {
        try {
          const f = await journeySvc(`/${id}/funnel`).getAsync();
          if (this._alive) this.setState({
            funnels: {
              ...(this.state.funnels || {}),
              [id]: f || {}
            }
          });
        } catch (e) {
          if (this._alive) this.setState({
            funnels: {
              ...(this.state.funnels || {}),
              [id]: {}
            }
          });
        }
      }
    });
    this.state = {
      journeys: null,
      automations: null,
      error: false,
      shopify: false,
      filter: null,
      comparing: false,
      compare: []
    };
    this._alive = true;
  }
  async componentDidMount() {
    try {
      const q = new URLSearchParams(window.location.search || window.location.hash.split("?")[1] || "");
      if (q.get("q")) this.setState({
        q: q.get("q")
      });
      if (q.get("show") === "single") this.setState({
        filter: "Single"
      });
    } catch (e) {}
    getOnboardingStatus(false).then(ob => this._alive !== false && this.setState({
      shopify: !!(ob && ob.shopify)
    })).catch(() => {});
    if (!(Auth.isAuthenticated() || (await Auth.attachOrSignIn()))) return;
    // Single emails are decoration on this page: their failure never blocks the journeys.
    emailSvc("/automations?range=DAY").getAsync().then(d => this._alive && this.setState({
      automations: d && Array.isArray(d.automations) ? d.automations : []
    })).catch(() => this._alive && this.setState({
      automations: []
    }));
    try {
      const d = await journeySvc().getAsync();
      if (this._alive) this.setState({
        journeys: Array.isArray(d) ? d : []
      });
    } catch (e) {
      if (this._alive) this.setState({
        error: true
      });
    }
  }
  componentWillUnmount() {
    this._alive = false;
  }
  async reload(patch) {
    try {
      const d = await journeySvc().getAsync();
      if (this._alive) this.setState({
        journeys: Array.isArray(d) ? d : [],
        busyId: null,
        ...(patch || {})
      });
    } catch (e) {
      if (this._alive) this.setState({
        busyId: null
      });
    }
  }
  renderComparison() {
    const sel = this.state.compare || [];
    const funnels = this.state.funnels || {};
    const byId = {};
    (this.state.journeys || []).forEach(j => {
      byId[j.id] = j;
    });
    const STAGES = [["enrolled", "Joined", "started the journey"], ["sent", "Got an email", "at least one email sent"], ["opened", "Opened", "opened at least one"], ["clicked", "Clicked", "clicked at least one"], ["completed", "Finished", "reached the last step"], ["exitedGoal", "Reached the goal", "left early because the goal was met"], ["conversions", "Ordered", "placed an order after an email"]];
    const raw = (id, k) => {
      const f = funnels[id];
      const t = f && f.totals || {};
      const j = byId[id] || {};
      return t[k] != null ? t[k] : j[k];
    };
    const val = (id, k) => Number(raw(id, k)) || 0;
    const hasRevenue = sel.some(id => raw(id, "revenue") != null);
    const attribution = sel.map(id => raw(id, "attributionDays")).find(d => d != null);
    const hint = `${sel.length} of up to 4 · each step as a share of the people who joined`;
    return /*#__PURE__*/React.createElement(Card, {
      title: "Compare journeys",
      hint: hint
    }, sel.length < 2 ? /*#__PURE__*/React.createElement(Empty, null, sel.length ? "Pick one more journey above to compare." : "Pick two to four journeys above to compare them. Journeys with the same start or goal compare best.") : /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table ec-cmp-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Step"), sel.map(id => /*#__PURE__*/React.createElement("th", {
      key: id,
      className: "n"
    }, (byId[id] || {}).name || id)))), /*#__PURE__*/React.createElement("tbody", null, STAGES.map(([k, label, sub]) => /*#__PURE__*/React.createElement("tr", {
      key: k
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, label), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, sub)), sel.map(id => {
      const n = val(id, k),
        base = val(id, "enrolled");
      const share = base ? Math.round(n / base * 100) : 0;
      return /*#__PURE__*/React.createElement("td", {
        key: id,
        className: "n"
      }, funnels[id] ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("b", null, num(n)), k !== "enrolled" && base ? /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, " \xB7 ", share, "%") : null, /*#__PURE__*/React.createElement("div", {
        className: "ec-cmp-bar"
      }, /*#__PURE__*/React.createElement("i", {
        style: {
          width: `${base ? Math.min(100, n / base * 100) : 0}%`
        }
      }))) : /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, "\u2026"));
    }))), hasRevenue ? /*#__PURE__*/React.createElement("tr", {
      className: "ec-cmp-money"
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, "Sales"), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, attribution ? `orders within ${attribution} days of an email` : "orders after an email")), sel.map(id => {
      const r = raw(id, "revenue");
      const base = val(id, "enrolled");
      const per = raw(id, "revenuePerEnrolled");
      return /*#__PURE__*/React.createElement("td", {
        key: id,
        className: "n"
      }, funnels[id] ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("b", null, r != null ? money(r) : "none"), r != null && base ? /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, " \xB7 ", money(per != null ? per : Number(r) / base), " per person") : null) : /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, "\u2026"));
    })) : null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, "Unsubscribed along the way")), sel.map(id => /*#__PURE__*/React.createElement("td", {
      key: id,
      className: "n dim"
    }, funnels[id] ? num(val(id, "exitedOptOut")) : "…")))))));
  }
  journeyMenu(j) {
    const h = this.props.history;
    const items = [];
    if (j.isTemplate) items.push({
      label: "Use template",
      run: () => h.push(`/Email/journeys/new?template=${encodeURIComponent(j.id)}`)
    });
    if (j.status !== "Archived") items.push({
      label: "Edit",
      run: () => h.push(`/Email/journeys/edit/${j.id}`)
    });
    items.push({
      label: "Duplicate",
      title: "Copy this journey as a new draft",
      run: () => this.duplicate(j)
    });
    if (j.status === "Running") items.push({
      label: "Pause",
      run: () => this.setStatus(j, "Paused")
    });
    if (j.status === "Paused") items.push({
      label: "Resume",
      run: () => this.setStatus(j, "Running")
    });
    if (j.status === "Archived") items.push({
      label: "Restore to drafts",
      title: "Moves it back to Drafts; nothing was deleted",
      run: () => this.setStatus(j, "Draft", {
        filter: "Draft"
      })
    });
    if (!j.isTemplate && j.status !== "Archived") items.push({
      label: "Compare with others",
      run: () => {
        this.setState({
          comparing: true
        });
        if ((this.state.compare || []).indexOf(j.id) < 0) this.toggleCompare(j.id);
      }
    });
    if (j.status !== "Running" && j.status !== "Archived") items.push({
      label: "Archive",
      danger: true,
      confirm: "Archive this journey? People already in it keep their place.",
      confirmLabel: "Yes, archive",
      run: () => this.setStatus(j, "Archived")
    });
    return items;
  }
  statusPill(status, isTemplate) {
    const tone = isTemplate ? "template" : String(status || "draft").toLowerCase();
    return /*#__PURE__*/React.createElement("span", {
      className: `ejl-status ${tone}`
    }, isTemplate ? "Template" : statusWord(status));
  }
  journeyCard(j) {
    const busy = this.state.busyId === j.id;
    const {
      labels,
      more
    } = journeyStepLabels(j.graph || {
      nodes: []
    }, [], 5);
    const chips = [triggerSentence(j)].concat(labels);
    const comparing = this.state.comparing && !j.isTemplate && j.status !== "Archived";
    const picked = (this.state.compare || []).indexOf(j.id) >= 0;
    const full = (this.state.compare || []).length >= 4 && !picked;
    const sent = j.sent != null ? j.sent : null;
    const opened = j.opened != null ? pctOf(j.opened, sent || j.enrolled) : j.openRate != null ? `${Math.round(Number(j.openRate) * (Number(j.openRate) <= 1 ? 100 : 1))}%` : null;
    const clicked = j.clicked != null ? pctOf(j.clicked, sent || j.enrolled) : j.clickRate != null ? `${Math.round(Number(j.clickRate) * (Number(j.clickRate) <= 1 ? 100 : 1))}%` : null;
    const onClick = comparing ? () => !full && this.toggleCompare(j.id) : this.open(j.id);
    return /*#__PURE__*/React.createElement("div", {
      key: j.id,
      className: `ejl-card${comparing ? " comparing" : ""}${picked ? " picked" : ""}${busy ? " busy" : ""}`,
      role: "link",
      tabIndex: 0,
      onClick: onClick,
      onKeyDown: e => {
        if (e.key === "Enter") onClick();
      },
      title: comparing ? full ? "You can compare up to four" : "Pick to compare" : "Open journey"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ejl-card-top"
    }, comparing ? /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: "ejl-pick",
      checked: picked,
      disabled: full,
      onChange: () => this.toggleCompare(j.id),
      onClick: e => e.stopPropagation(),
      "aria-label": "Compare this journey"
    }) : null, /*#__PURE__*/React.createElement("b", {
      className: "ejl-name"
    }, j.name), this.state.shopify && shopifyOwnsJourney(j) && j.status !== "Running" && !j.shopifyPausedConfirmed ? /*#__PURE__*/React.createElement("span", {
      className: "ejl-status warn",
      title: "Pause the matching automation in Shopify Email before turning this on, or customers get two emails"
    }, "Also in Shopify Email") : null, !j.isTemplate && isSingleJourney(j.graph) ? /*#__PURE__*/React.createElement("span", {
      className: "ejl-status single"
    }, "Single email") : null, this.statusPill(j.status, j.isTemplate), busy ? /*#__PURE__*/React.createElement("span", {
      className: "ejl-busy"
    }, "Saving\u2026") : /*#__PURE__*/React.createElement(CardMenu, {
      items: this.journeyMenu(j)
    })), /*#__PURE__*/React.createElement("div", {
      className: "ejl-chips"
    }, chips.map((c, i) => /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, i ? /*#__PURE__*/React.createElement("span", {
      className: "ejl-arrow",
      "aria-hidden": "true"
    }, "\u2192") : null, /*#__PURE__*/React.createElement("span", {
      className: `ejl-chip${i === 0 ? " start" : ""}`
    }, c))), more ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "ejl-arrow",
      "aria-hidden": "true"
    }, "\u2192"), /*#__PURE__*/React.createElement("span", {
      className: "ejl-chip more"
    }, more, " more step", more === 1 ? "" : "s")) : null), /*#__PURE__*/React.createElement("div", {
      className: "ejl-foot"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, num(j.enrolled)), " joined"), opened != null ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, opened), " opened") : null, clicked != null ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, clicked), " clicked") : null, "revenue" in j ? /*#__PURE__*/React.createElement("span", {
      title: j.attributionDays ? `orders within ${j.attributionDays} days of an email` : "orders after an email"
    }, /*#__PURE__*/React.createElement("b", null, money(j.revenue)), " sales") : null, /*#__PURE__*/React.createElement("span", {
      className: "ejl-grow"
    }), stalled(j) ? /*#__PURE__*/React.createElement("span", {
      className: "ejl-warn"
    }, "No one has joined in 2 weeks. ", /*#__PURE__*/React.createElement(Link, {
      to: `/Email/journeys/edit/${j.id}`,
      onClick: e => e.stopPropagation()
    }, "Check the start")) : j.lastEnrolledDate ? /*#__PURE__*/React.createElement("span", {
      title: new Date(j.lastEnrolledDate).toLocaleString()
    }, "last joined ", agoText(j.lastEnrolledDate)) : j.status === "Draft" ? /*#__PURE__*/React.createElement("span", null, j.modifiedDate ? `edited ${agoText(j.modifiedDate)}` : "not started yet") : null));
  }
  singleCard(a) {
    const m = a.metrics || {};
    const h = this.props.history;
    const items = [{
      label: "Open",
      run: () => h.push(`/Email/automations/detail/${a.id}`)
    }, {
      label: "Edit",
      run: () => h.push(`/Email/automations/edit/${a.id}`)
    }];
    const go = () => h.push(`/Email/automations/detail/${a.id}`);
    return /*#__PURE__*/React.createElement("div", {
      key: `a-${a.id}`,
      className: "ejl-card",
      role: "link",
      tabIndex: 0,
      onClick: go,
      onKeyDown: e => {
        if (e.key === "Enter") go();
      },
      title: "Open single email"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ejl-card-top"
    }, /*#__PURE__*/React.createElement("b", {
      className: "ejl-name"
    }, a.name), /*#__PURE__*/React.createElement("span", {
      className: "ejl-status single"
    }, "Single email"), this.statusPill(a.status), /*#__PURE__*/React.createElement(CardMenu, {
      items: items
    })), /*#__PURE__*/React.createElement("div", {
      className: "ejl-chips"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ejl-chip start"
    }, triggerSentence(a)), /*#__PURE__*/React.createElement("span", {
      className: "ejl-arrow",
      "aria-hidden": "true"
    }, "\u2192"), /*#__PURE__*/React.createElement("span", {
      className: "ejl-chip"
    }, waitPhrase(a.scheduleConfig)), /*#__PURE__*/React.createElement("span", {
      className: "ejl-arrow",
      "aria-hidden": "true"
    }, "\u2192"), /*#__PURE__*/React.createElement("span", {
      className: "ejl-chip"
    }, a.emailSubject || a.subject || "The email")), /*#__PURE__*/React.createElement("div", {
      className: "ejl-foot"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, num(m.sent)), " sent"), Number(m.uniqueOpens) > 0 ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, pctOf(m.uniqueOpens, m.sent) || num(m.uniqueOpens)), " opened") : null, Number(m.uniqueClicks) > 0 ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, pctOf(m.uniqueClicks, m.sent) || num(m.uniqueClicks)), " clicked") : null, /*#__PURE__*/React.createElement("span", {
      className: "ejl-grow"
    }), /*#__PURE__*/React.createElement("span", null, "each person gets it once")));
  }
  render() {
    if (!hasTenantFeature("emailAutomation")) {
      return /*#__PURE__*/React.createElement(CssContainer, {
        cls: "margin-squeeze"
      }, /*#__PURE__*/React.createElement("p", {
        className: "module-empty"
      }, "Email Automation isn't set up for this workspace. Contact Plunk to turn it on."));
    }
    const {
      journeys,
      error,
      comparing
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, {
      message: "Journeys could not be loaded."
    });
    if (!journeys) return /*#__PURE__*/React.createElement(Loader, null);
    const automations = (this.state.automations || []).filter(a => a.status !== "Migrated"); // migrated into journeys (2026-10-04): parked, never shown

    const counts = {
      active: 0,
      Running: 0,
      Paused: 0,
      Draft: 0,
      Single: 0,
      Template: 0,
      Archived: 0
    };
    journeys.forEach(j => {
      if (j.isTemplate) {
        counts.Template++;
        return;
      }
      if (counts[j.status] != null) counts[j.status]++;
      if (j.status !== "Archived") {
        counts.active++;
        if (isSingleJourney(j.graph)) counts.Single++;
      }
    });
    automations.forEach(a => {
      counts.Single++;
      if (counts[a.status] != null && a.status !== "Archived") counts[a.status]++;
      if (a.status !== "Archived") counts.active++;
    });
    const PILLS = [["active", "All"], ["Running", "Running"], ["Paused", "Paused"], ["Draft", "Drafts"], ["Single", "Single emails"], ["Template", "Templates"]];
    const filter = this.state.filter || (counts.Running ? "Running" : "active");
    const q = (this.state.q || "").toLowerCase();
    const match = j => !q || `${j.name} ${j.kind === "single" ? triggerLabel(j.raw) : triggerText(j)} ${triggerSentence(j.kind === "single" ? j.raw : j)}`.toLowerCase().includes(q);
    const inFilter = j => {
      if (j.kind === "single") return filter === "Single" || (filter === "active" ? j.status !== "Archived" : ["Running", "Paused", "Draft"].includes(filter) && j.status === filter);
      return filter === "Template" ? !!j.isTemplate : j.isTemplate ? false : filter === "Single" ? j.status !== "Archived" && isSingleJourney(j.graph) : filter === "active" ? j.status !== "Archived" : j.status === filter;
    };
    const order = {
      Running: 0,
      Paused: 1,
      Draft: 2,
      Archived: 3
    };
    const singles = automations.map(a => ({
      ...a,
      kind: "single",
      raw: a,
      id: a.id,
      enrolled: (a.metrics || {}).sent,
      modifiedDate: a.modifiedDate || a.createdDate
    }));
    const rows = journeys.concat(singles).filter(inFilter).filter(match).sort((a, b) => (order[a.status] ?? 9) - (order[b.status] ?? 9) || String(b.modifiedDate || "").localeCompare(String(a.modifiedDate || "")));
    const saved = journeys.filter(j => j.isTemplate && j.status !== "Archived");
    const emptyText = filter === "Archived" ? "No archived journeys. Archiving keeps a journey and its history, and you can restore it from here any time." : filter === "Draft" ? "No drafts. Start one from New, then Journey." : filter === "Template" ? "No saved templates yet. Open any journey, tick \"Keep as a template\" in its last step, and it shows here and when you start a new journey." : filter === "Single" ? "No single emails yet. A single email goes out once to each person when something happens. Start one from New, then Single email." : filter === "Paused" ? "No paused journeys." : filter === "Running" ? "No running journeys." : this.state.shopify ? "No journeys yet. Shopify Email keeps your basics; build here what it can't run, like reorder reminders, follow-ups with recommendations, and journeys based on what people do." : "No journeys yet. Start one from New, then Journey.";
    const archivedOn = filter === "Archived";
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view ejl-view"
    }, /*#__PURE__*/React.createElement(EmailHeader, null), this.state.notice ? /*#__PURE__*/React.createElement("div", {
      className: "wa-notice danger"
    }, this.state.notice) : null, /*#__PURE__*/React.createElement("div", {
      className: "ejl-bar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ejl-pills",
      role: "tablist",
      "aria-label": "Show"
    }, PILLS.map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      type: "button",
      role: "tab",
      "aria-selected": filter === k,
      className: `ejl-pill${filter === k ? " on" : ""}`,
      onClick: () => this.setState({
        filter: k
      })
    }, l, k !== "Template" && counts[k] ? ` ${num(counts[k])}` : ""))), /*#__PURE__*/React.createElement("span", {
      className: "ejl-grow"
    }), counts.Archived || archivedOn ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ejl-textbtn",
      onClick: () => this.setState({
        filter: archivedOn ? null : "Archived"
      })
    }, archivedOn ? "Hide archived" : `Show archived (${num(counts.Archived)})`) : null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: `ejl-textbtn${comparing ? " on" : ""}`,
      onClick: () => this.setState(comparing ? {
        comparing: false,
        compare: []
      } : {
        comparing: true
      })
    }, comparing ? "Done comparing" : "Compare journeys"), /*#__PURE__*/React.createElement("label", {
      className: "ejl-search"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "15",
      height: "15",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "11",
      cy: "11",
      r: "7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 20l-3.5-3.5"
    })), /*#__PURE__*/React.createElement("input", {
      value: this.state.q || "",
      onChange: e => this.setState({
        q: e.target.value
      }),
      placeholder: "Search journeys",
      "aria-label": "Search journeys"
    }))), comparing ? /*#__PURE__*/React.createElement("div", {
      className: "ejl-compare-hint"
    }, "Pick up to four journeys to compare. ", (this.state.compare || []).length, " picked.") : null, comparing ? this.renderComparison() : null, rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "ejl-grid"
    }, rows.map(r => r.kind === "single" ? this.singleCard(r.raw) : this.journeyCard(r))) : /*#__PURE__*/React.createElement("div", {
      className: "ejl-empty"
    }, q ? "No journey matches your search." : emptyText), !comparing && !archivedOn ? /*#__PURE__*/React.createElement("div", {
      className: "ejl-ready"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ejl-ready-text"
    }, /*#__PURE__*/React.createElement("b", null, "Start from a ready-made journey"), /*#__PURE__*/React.createElement("span", null, READY_MADE.map(([k, l], i) => /*#__PURE__*/React.createElement(React.Fragment, {
      key: k
    }, i ? ", " : "", /*#__PURE__*/React.createElement(Link, {
      to: `/Email/journeys/new?template=${k}`
    }, l))), saved.slice(0, 4).map(t => /*#__PURE__*/React.createElement(React.Fragment, {
      key: t.id
    }, ", ", /*#__PURE__*/React.createElement(Link, {
      to: `/Email/journeys/new?template=${encodeURIComponent(t.id)}`
    }, t.name))))), /*#__PURE__*/React.createElement(Link, {
      className: "ejl-ready-btn",
      to: "/Email/journeys/new"
    }, "See templates")) : null);
  }
}
export default withRouter(EmailJourneysViewComponent);